// @flow
import * as React from 'react';
import LACrownContainer from './LACrown/LACrownContainer';
import WhiteLabelCrownContainer from './WhiteLabelCrown/WhiteLabelCrownContainer';

type Props = {|
    pathname: string,
    whiteLabel: boolean,
|};

const Crown = ({ pathname, whiteLabel }: Props) => {
    return whiteLabel ? <WhiteLabelCrownContainer /> : <LACrownContainer pathname={pathname} />;
};

export default React.memo<Props>(Crown);
